import carLocate from "@/components/locate/carLocate";
import allLocate from "@/components/locate/allLocate";
import personLocate from "@/components/locate/personLocate";
import locus from "@/components/locus/";
import oil from "@/components/oil/oil";
import locusPeson from "@/components/locusPeson/";
import carVideo from "@/components/video/carVideo";
import carVideoHistory from "@/components/video/carVideoHistory";
var data = [
  {
    path: "/carLocate",
    component: carLocate
  },
  {
    path: "/carLocate1",
    component: allLocate
  },
  {
    path: "/personLocate",
    component: personLocate
  },
  {
    path: "/personLocate1",
    component: personLocate
  },
  {
    path: "/locus",
    component: locus
  },
  {
    path: "/locusPeson",
    component: locusPeson
  },
  {
    path: "/carVideo",
    component: carVideo
  }, {
    path: "/carVideoHistory",
    component: carVideoHistory
  },
  {
    path: "/oil",
    component: oil
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/locateLocus.js